import React, { useEffect } from 'react';
import NextImage from 'next/image';
import styles from './style.module.scss';
import Button from 'components/control/button';

type Props = {
    image : {
        src: string;
        altText: string;
    };
    title: string;
    description: string;
    cta?: {
        text: string;
        onClick: (args: unknown) => void;
    };
    doOnError?: (args?: unknown) => void;
};

const ErrorState = (props: Props) => {

  useEffect(() => {
    if (props?.doOnError) {
      props?.doOnError();
    }
  }, [props]);

  return (
    <div className={styles['container']}>
      <div className={styles['secondary-container']}>
        <NextImage className={styles['image']} src={props?.image?.src} alt={props?.image?.altText} width={300} height={300} />         
        <h1 className={styles['heading']}>{props?.title}</h1>
        {props?.description?.split('\n').map(line => <p key={line}>{line}</p>)}        
        {props?.cta && <Button className={styles['cta-button']} theme='tertiary' label={props?.cta?.text} onClick={props?.cta?.onClick} />}
      </div>
    </div>
  );
};

export default ErrorState;